/// <reference types="react" />

import * as React from "react";

import { ActionCreatorManager } from "DistributedTaskControls/Common/Actions/ActionCreatorManager";
import * as ComponentBase from "DistributedTaskControls/Common/Components/Base";
import { DropDownInputControl, IDropDownItem } from "DistributedTaskControls/SharedControls/InputControls/Components/DropDownInputComponent";
import { Dropdown } from "VSSUI/Dropdown";
import { IListBoxItem } from "VSSUI/ListBox";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";
import { ICalloutContentProps } from "DistributedTaskControls/Components/CalloutComponent";
import { Component as InfoButton } from "DistributedTaskControls/Components/InfoButton";
import { TaskGroupPropertiesStore, ITaskGroupPropertiesState } from "DistributedTaskControls/Stores/TaskGroupPropertiesStore";
import { MultiLineInputComponent } from "DistributedTaskControls/SharedControls/InputControls/Components/MultilineInputComponent";
import * as Resources from "DistributedTaskControls/Resources/TFS.Resources.DistributedTaskControls";
import { StoreManager } from "DistributedTaskControls/Common/Stores/StoreManager";
import { StringInputComponent } from "DistributedTaskControls/SharedControls/InputControls/Components/StringInputComponent";
import { TaskGroupPropertiesActionCreator } from "DistributedTaskControls/Actions/TaskGroupPropertiesActionCreator";

import * as Utils_String from "VSS/Utils/String";

import "VSS/LoaderPlugins/Css!DistributedTaskControls/Components/Task/TaskGroupPropertiesView";

export class TaskGroupPropertiesView extends ComponentBase.Component<ComponentBase.IProps, ITaskGroupPropertiesState>{

    constructor(props: ComponentBase.IProps) {
        super(props);
        this._dropdownSelection = new DropdownSelection();
        this._dropdownSelection.multiSelect = false;
    }

    public componentWillMount() {
        this._taskGroupPropertiesStore = StoreManager.GetStore<TaskGroupPropertiesStore>(TaskGroupPropertiesStore, this.props.instanceId);
        this._taskGroupPropertiesActionCreator = ActionCreatorManager.GetActionCreator<TaskGroupPropertiesActionCreator>(TaskGroupPropertiesActionCreator, this.props.instanceId);
        this.setState(this._taskGroupPropertiesStore.getState());

        this._taskGroupPropertiesStore.addChangedListener(this._onChange);
    }

    public componentWillUnmount() {
        this._taskGroupPropertiesStore.removeChangedListener(this._onChange);
    }

    private _onChange = (): void => {
        this.setState(this._taskGroupPropertiesStore.getState());
    }

    public render(): JSX.Element {
        return (
            <div className={this.props.cssClass}>
                {  /* Task group name label and text field */}

                <div className="input-field-component">
                    <StringInputComponent
                        label={Resources.NameLabel}
                        required={true}
                        value={this.state.name}
                        onValueChanged={this._onTaskGroupNameChanged}
                        getErrorMessage={(value: string) => { return this._getGroupErrorMessage(value); }}
                        inputClassName={TaskGroupPropertiesView.taskGroupNameFieldClass} />
                </div>


                {  /* Description for Task Group */}

                <div className="input-field-component">
                    <MultiLineInputComponent
                        label={Resources.Description}
                        isNotResizable={true}
                        value={this.state.description ? this.state.description : Utils_String.empty}
                        onValueChanged={this._onTaskGroupDescriptionChanged} />
                </div>

                { /* Category of task group */}

                <div className="dtc-task-group-dialog-category">
                    <div className="label-with-info">
                        <div className="dtc-task-group-label">{Resources.CategoryText}</div>
                        <InfoButton
                            iconAriaLabel={Resources.TaskGroupCategoryInfoIconAriaLabel}
                            calloutContent={this._getCalloutContent()}
                            isIconFocusable={true}                            
                        />
                    </div>

                    <Dropdown                    
                        ariaLabel={Resources.CategoryText}
                        ariaDescribedBy="id-category-description"
                        items={this._getDropdownItems()}
                        selection={this._getSelection()}
                        onSelect={(event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<any>) => { this._onTaskGroupCategoryChanged(item); }}
                    />
                </div>
            </div>
        );
    }

    private _getDropdownItems(): IListBoxItem[] {
        let items: IListBoxItem[] = [];

        items.push({ id: "Build", text: Resources.Build });
        items.push({ id: "Deploy", text: Resources.Deploy });
        items.push({ id: "Package", text: Resources.Package });
        items.push({ id: "Utility", text: Resources.Utility });
        items.push({ id: "Test", text: Resources.Test });
        return items;
    }

    private _onTaskGroupNameChanged = (newValue: string): void => {
        this._taskGroupPropertiesActionCreator.changeTaskGroupName(newValue);
    }

    private _onTaskGroupDescriptionChanged = (newValue: string): void => {
        this._taskGroupPropertiesActionCreator.changeTaskGroupDescription(newValue);
    }

    private _onTaskGroupCategoryChanged = (newValue: IListBoxItem): void => {
        this._getDropdownItems().map((item, index) => {
            if (newValue.id.toLowerCase() === item.id.toLowerCase()) {
                this._dropdownSelection.select(index);
            }
        });

        this._taskGroupPropertiesActionCreator.changeTaskGroupCategory(newValue.id.toString());
    }

    private _getSelection(): DropdownSelection {
        let items = this._getDropdownItems();

        if (!!items && items.length > 0) {
            items.map((item, index) => {
                if (item.id.toLowerCase() === this.state.category.toLowerCase()) {
                    this._dropdownSelection.select(index);
                }
            });
        }

        return this._dropdownSelection;
    }

    private _getCalloutContent(): ICalloutContentProps {
        return {
            calloutDescription: Resources.GroupDialogboxCalloutDescription
        } as ICalloutContentProps;
    }

    private _getGroupErrorMessage = (value: string): string => {
        if (value.length === 0) {
            return Resources.RequiredInputErrorMessage;
        }
        return Utils_String.empty;
    }

    public static readonly taskGroupNameFieldClass: string = "dtc-task-group-properties-name-textfield";

    private _dropdownSelection: DropdownSelection;
    private _taskGroupPropertiesStore: TaskGroupPropertiesStore;
    private _taskGroupPropertiesActionCreator: TaskGroupPropertiesActionCreator;
}